/**
 * components/InfraHealthBadge.jsx — mini badge en header del admin.
 * Polls /admin/infra-audit/health-summary cada 60s.
 * Muestra "Salud: 62/100" con dot rojo si hay críticos, amber si hay warnings.
 */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/apiClient";

export default function InfraHealthBadge() {
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    let alive = true;
    const fetch = () => {
      api.get("/admin/infra-audit/health-summary")
        .then(({ data: res }) => { if (alive) setData(res); })
        .catch(() => {});
    };
    fetch();
    const t = setInterval(fetch, 60000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  if (!data?.has_data || data.score == null) return null;

  const critical = data.summary?.critical || 0;
  const warning = data.summary?.warning || 0;
  let tone = "bg-emerald-50 border-emerald-200 text-emerald-800";
  let dot = "bg-emerald-500";
  let dotPulse = "";
  if (critical > 0) {
    tone = "bg-rose-50 border-rose-300 text-rose-800";
    dot = "bg-rose-500";
    dotPulse = "animate-pulse";
  } else if (warning > 0) {
    tone = "bg-amber-50 border-amber-300 text-amber-800";
    dot = "bg-amber-500";
  }

  return (
    <button
      type="button"
      onClick={() => navigate("/admin/infra-audit")}
      className={`hidden md:inline-flex items-center gap-2 px-3 h-8 border text-xs font-medium transition-colors ${tone} hover:brightness-95`}
      title={`${critical} críticos · ${warning} warnings · ${data.summary?.ok || 0} OK`}
      data-testid="infra-health-badge"
    >
      <span className={`inline-block w-2 h-2 rounded-full ${dot} ${dotPulse}`} />
      <span>Salud: {data.score}/100</span>
      {critical > 0 && (
        <span className="ml-1 bg-rose-600 text-white px-1.5 py-[1px] text-[10px] rounded-sm" data-testid="badge-critical-count">
          {critical}
        </span>
      )}
    </button>
  );
}
